/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { FormFieldType, StagedFieldsGroupFormField } from '../typings';
import { setConditionalParentFields } from '../store';

export class StagedFieldsGroupFormFieldBuilder extends BaseCompoundFormFieldBuilder<StagedFieldsGroupFormField> {
  protected _type = FormFieldType.StagedFieldsGroup;
  protected _typeValue = FormFieldType.StagedFieldsGroup;

  // @ts-ignore
  private _title: StagedFieldsGroupFormField['title'] = 'Title not provided';
  // @ts-ignore
  private _isRequired: StagedFieldsGroupFormField['isRequired'] = false;
  // @ts-ignore
  private _maxItems?: StagedFieldsGroupFormField['maxItems'];
  // @ts-ignore
  private _minItems?: StagedFieldsGroupFormField['minItems'];
  // @ts-ignore
  private _index: StagedFieldsGroupFormField['index'] = 0;
  // @ts-ignore
  private _questionIfOptional?: StagedFieldsGroupFormField['questionIfOptional'];
  // @ts-ignore
  private _titleWhenFilled?: StagedFieldsGroupFormField['titleWhenFilled'];
  // @ts-ignore
  private _hintWhenFilled?: StagedFieldsGroupFormField['hintWhenFilled'];
  // @ts-ignore
  private _firstStageFields: StagedFieldsGroupFormField['firstStageFields'] =
    [];
  // @ts-ignore
  private _otherFields: StagedFieldsGroupFormField['otherFields'] = [];
  // @ts-ignore
  private _allowRemove: StagedFieldsGroupFormField['allowRemove'];
  // @ts-ignore
  private _restriction: StagedFieldsGroupFormField['restriction'];

  constructor() {
    super();
  }

  public restriction(value: StagedFieldsGroupFormField['restriction']): this {
    this._restriction = value;
    return this;
  }

  public title(value: StagedFieldsGroupFormField['title']): this {
    this._title = value;
    return this;
  }

  public isRequired(value: StagedFieldsGroupFormField['isRequired']): this {
    this._isRequired = value;
    return this;
  }

  public maxItems(value: StagedFieldsGroupFormField['maxItems']): this {
    this._maxItems = value;
    return this;
  }

  public minItems(value: StagedFieldsGroupFormField['minItems']): this {
    this._minItems = value;
    return this;
  }

  public index(value: StagedFieldsGroupFormField['index']): this {
    this._index = value;
    return this;
  }

  public questionIfOptional(
    value: StagedFieldsGroupFormField['questionIfOptional'],
  ): this {
    this._questionIfOptional = value;
    return this;
  }

  public titleWhenFilled(
    value: StagedFieldsGroupFormField['titleWhenFilled'],
  ): this {
    this._titleWhenFilled = value;
    return this;
  }

  public hintWhenFilled(
    value: StagedFieldsGroupFormField['hintWhenFilled'],
  ): this {
    this._hintWhenFilled = value;
    return this;
  }

  // TODO: Add method to add single field
  public firstStageFields(
    value: StagedFieldsGroupFormField['firstStageFields'],
  ): this {
    this._firstStageFields = [...value];

    const childrenIds = [];

    if (this._firstStageFields) {
      childrenIds.push(...this._firstStageFields.map(field => field.fieldId));
    }
    if (this._otherFields) {
      childrenIds.push(...this._otherFields.map(field => field.fieldId));
    }

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  // TODO: Add method to add single field
  public otherFields(value: StagedFieldsGroupFormField['otherFields']): this {
    this._otherFields = [...value];

    const childrenIds = [];

    if (this._firstStageFields) {
      childrenIds.push(...this._firstStageFields.map(field => field.fieldId));
    }
    if (this._otherFields) {
      childrenIds.push(...this._otherFields.map(field => field.fieldId));
    }

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  public allowRemove(value: StagedFieldsGroupFormField['allowRemove']): this {
    this._allowRemove = value;
    return this;
  }
}
